import { FC, useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { IFormData } from './Form.props';

import formDataStatic from '@/data/feedbackFormData.json';
import { Heading } from '@/components/typography';
import { AnimatedCard } from '@/components/animation/AnimatedCard';
import { FeedbackInput } from '@/components/inputs/Feedback';
import axios from 'axios';
import { FormModal } from '@/components/common/FormModal';

export const FeedbackForm: FC = (): JSX.Element => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // watch,
    clearErrors,
    reset,

    // formState: { errors, isValid },
    // setValue: setFormValue,
    // trigger,
    // getFieldState,
    // getValues,
    // setError,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } = useForm<any>({
    criteriaMode: 'all',
    mode: 'onChange',
  });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isSendErr, setIsSendErr] = useState(false);
  const [language, setLanguage] = useState<'EN' | 'UA'>('UA');
  const { t } = useTranslation('common');

  const thankText = t('modalFormThank');
  const errText = t('formErr');

  const router = useRouter();

  useEffect(() => {
    router.locale == 'en' ? setLanguage('EN') : setLanguage('UA');
    reset();
  }, [reset, router]);

  const closeForm = () => {
    setIsOpenModal(false);
  };

  const formDataValues = formDataStatic[language];

  const onSubmit: SubmitHandler<IFormData> = async data => {
    try {
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      // mail - info@microkhim.com
      const responseSend = await axios.post(
        'https://formsubmit.co/ajax/f4bad6ee37f83e9404ce7e22228a2e86',
        {
          title: 'Форма зворотнього звязку',
          name: data.feedbackFormName,
          phone: data.feedbackFormPhone,
          email: data.feedbackFormEmail,
          comment: data.feedbackFormComment,
        },
      );

      if (responseSend.status == 200) {
        setIsSendErr(false);
        setIsOpenModal(true);
        reset();
      }
    } catch (error) {
      setIsSendErr(true);
      console.log(error, 'err');
    }
  };

  return (
    <AnimatedCard>
      <form
        className="w-full pb-15"
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="on"
      >
        {formDataValues?.title && (
          <Heading tag="p" withDivider content={formDataValues.title} />
        )}

        <div className="relative mb-5">
          <FeedbackInput
            required={true}
            type={'text'}
            name={'feedbackFormName'}
            register={register}
            placeholder={formDataValues.name}
            onChange={() => clearErrors('feedbackFormName')}
            locale={language}
          />{' '}
          {errors?.feedbackFormName?.message && (
            <p className="pt-0.5 text-error">
              {errors.feedbackFormName.message.toString()}
            </p>
          )}
        </div>

        <div className="mb-5 flex w-full justify-between">
          <div className="relative mr-5 w-2/4">
            <FeedbackInput
              required={true}
              type={'tel'}
              name={'feedbackFormPhone'}
              register={register}
              placeholder={formDataValues.phone}
              onChange={() => clearErrors('feedbackFormPhone')}
              locale={language}
            />{' '}
            {errors?.feedbackFormPhone?.message && (
              <p className="pt-0.5 text-error">
                {errors.feedbackFormPhone.message.toString()}
              </p>
            )}
          </div>

          <div className="w-2/4">
            <FeedbackInput
              required={true}
              type={'email'}
              name={'feedbackFormEmail'}
              register={register}
              placeholder={formDataValues.email}
              onChange={() => clearErrors('feedbackFormEmail')}
              locale={language}
            />{' '}
            {errors?.feedbackFormEmail?.message && (
              <p className="pt-0.5 text-error">
                {errors.feedbackFormEmail.message.toString()}
              </p>
            )}
          </div>
        </div>
        <div className="mb-5">
          <FeedbackInput
            required={false}
            type={'textarea'}
            name={'feedbackFormComment'}
            register={register}
            placeholder={formDataValues.textarea}
            onChange={() => clearErrors('feedbackFormComment')}
            locale={language}
          />
        </div>

        <div className="mb-5">
          <div
            className="text-base text-sm leading-[14px] md:text-start lg:col-span-3 lg:col-start-5 lg:row-start-2"
            dangerouslySetInnerHTML={{ __html: formDataValues.agreement }}
          ></div>
        </div>

        {formDataValues?.submit && (
          <button
            type="submit"
            className="focus:ring-accentAdditional-300 dark:bg-accentAdditional-600 dark:focus:ring-accentAdditional-800 dark:hover:bg-accentAdditional-700 w-full rounded-lg bg-accentMain px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-accentAdditional focus:outline-none  sm:w-auto"
          >
            {formDataValues.submit.label}
          </button>
        )}

        {isSendErr ? <p className="pt-0.5 text-error">{errText}</p> : null}
      </form>
      <FormModal closeModal={closeForm} isOpen={isOpenModal} text={thankText} />
    </AnimatedCard>
  );
};
